module.exports = __webpack_public_path__ + "img/上海航天-1.e2e3b0f4.png";